/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceGroupDto } from '../../models/device-group-dto';

export interface DeviceGroupControllerDelete$Params {
  id: string;
  clientWorkspaceId: string;
}

export function deviceGroupControllerDelete(http: HttpClient, rootUrl: string, params: DeviceGroupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceGroupDto>;
    })
  );
}

deviceGroupControllerDelete.PATH = '/api/device-group/{clientWorkspaceId}/{id}';
